import { render, staticRenderFns } from "./CreateCommitteeModal.vue?vue&type=template&id=bc6b9cca"
import script from "./CreateCommitteeModal.vue?vue&type=script&lang=js"
export * from "./CreateCommitteeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports